import MentionInput from "@common/components/mentionInput/MentionInput";
import { DotLegalCheckbox, DotLegalDialog, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import useSystemNotificationDialogHooks from "./SystemNotificationDialog.hooks";
import { SystemNotificationViewModel } from "../SystemNotifications.types";

export interface ISystemNotificationDialogProps {
    onDialogClose: () => void;
    onSave: () => void;
    selectedSystemNotification?: SystemNotificationViewModel;
}

function SystemNotificationDialog(props: ISystemNotificationDialogProps) {
    const { translateString } = useTranslation();
    const { saveModel, onTitleChange, onContentChange, createSystemNotification, validation, isSaving, isAlreadyPublished, isEdit } =
        useSystemNotificationDialogHooks(props);

    return (
        <DotLegalDialog
            buttonOkText={isAlreadyPublished ? translateString("save") : translateString("publish")}
            header={isEdit ? translateString("editSystemNotification") : translateString("createSystemAnnouncement")}
            open
            size="md"
            onDialogClose={() => props.onDialogClose()}
            onOkClick={() => createSystemNotification(true)}
            inProgress={isSaving}
            secondaryButtonLoading={isSaving}
            onSecondaryButtonClick={isAlreadyPublished ? undefined : () => createSystemNotification(false)}
            secondaryButtonText={isAlreadyPublished ? undefined : translateString("save")}
        >
            <DotLegalTextField
                label={translateString("title")}
                value={saveModel.title ?? ""}
                debounce={false}
                onChange={(value) => onTitleChange(value)}
                errorText={validation.getErrorsForDisplay("title")}
            />

            <MentionInput
                label={translateString("content")}
                value={saveModel.content}
                onChange={(value) => onContentChange(value)}
                disableMentions
                multiline
                rows={15}
                errorText={validation.getErrorsForDisplay("content")}
                reportEveryChange
                enableImageUpload
            />
        </DotLegalDialog>
    );
}

export default SystemNotificationDialog;
